export const trackHubspotPageView = (path: string) => {
    window._hsq = window._hsq || [];
    window._hsq.push(['setPath', path]);
    window._hsq.push(['trackPageView']);
}